import React from 'react'
import {Link} from 'react-router-dom'
import Button from "components/CustomButtons/Button.js";

export default function Progress()
{
    return (
        <>
          <Button
                component={Link}
                variant="outlined" 
                color="secondary"
                size="lg"
                to='/'
                rel="noopener noreferrer"
              >
                Home
              </Button>
            <h1 style={{
                textAlign:'center'
            }}>Soon</h1>
        </>
    )
}